import { nextTick, watch } from 'vue'

const useJs = (state) => {
  watch(() => state.js, _run, { immediate: true })
}

const _run = async (js) => {
  // CMS-authored inline JS is written for a browser and is sandboxed by the
  // page's origin/CSP there. Evaluating it during a server render would run
  // it inside the Node process instead, with no such boundary (VIP-12037).
  if (import.meta.env.SSR) return
  await nextTick()
  Function(js)()
}

export { useJs }
